/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkSendInvitationResponseInvitedUsersInner } from './BulkSendInvitationResponseInvitedUsersInner';
import {
    BulkSendInvitationResponseInvitedUsersInnerFromJSON,
    BulkSendInvitationResponseInvitedUsersInnerFromJSONTyped,
    BulkSendInvitationResponseInvitedUsersInnerToJSON,
} from './BulkSendInvitationResponseInvitedUsersInner';
import type { ContentInCompanySpaceUpgradeResponseOwningCompanySpace } from './ContentInCompanySpaceUpgradeResponseOwningCompanySpace';
import {
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSON,
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSONTyped,
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceToJSON,
} from './ContentInCompanySpaceUpgradeResponseOwningCompanySpace';
import type { ContentLearningEventParticipantIndexResponseLearningEvent } from './ContentLearningEventParticipantIndexResponseLearningEvent';
import {
    ContentLearningEventParticipantIndexResponseLearningEventFromJSON,
    ContentLearningEventParticipantIndexResponseLearningEventFromJSONTyped,
    ContentLearningEventParticipantIndexResponseLearningEventToJSON,
} from './ContentLearningEventParticipantIndexResponseLearningEvent';
import type { ContentLearningEventShowResponseOrdersInnerOrderCreator } from './ContentLearningEventShowResponseOrdersInnerOrderCreator';
import {
    ContentLearningEventShowResponseOrdersInnerOrderCreatorFromJSON,
    ContentLearningEventShowResponseOrdersInnerOrderCreatorFromJSONTyped,
    ContentLearningEventShowResponseOrdersInnerOrderCreatorToJSON,
} from './ContentLearningEventShowResponseOrdersInnerOrderCreator';

/**
 * List of orders for a learning event. Can be filtered via payment_methods e.g. 'payment_methods=[bank_transfer]', 'payment_methods=[gateway]', 'payment_methods=[code]' and internal e.g. 'internal=true', 'internal=false'. Can be paginated via page and per_page params.
 * @export
 * @interface ContentLearningEventOrderIndexResponse
 */
export interface ContentLearningEventOrderIndexResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    invitation_link: string;
    /**
     * 
     * @type {ContentLearningEventShowResponseOrdersInnerOrderCreator}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    order_creator?: ContentLearningEventShowResponseOrdersInnerOrderCreator;
    /**
     * 
     * @type {string}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    company_email?: string;
    /**
     * 
     * @type {number}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    participants_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    license_count?: number;
    /**
     * 
     * @type {string}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    settled_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    submitted_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    order_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    payment_method?: string;
    /**
     * 
     * @type {ContentLearningEventParticipantIndexResponseLearningEvent}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    learning_event?: ContentLearningEventParticipantIndexResponseLearningEvent;
    /**
     * 
     * @type {Array<BulkSendInvitationResponseInvitedUsersInner>}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    participants?: Array<BulkSendInvitationResponseInvitedUsersInner>;
    /**
     * 
     * @type {ContentInCompanySpaceUpgradeResponseOwningCompanySpace}
     * @memberof ContentLearningEventOrderIndexResponse
     */
    company_space?: ContentInCompanySpaceUpgradeResponseOwningCompanySpace;
}

/**
 * Check if a given object implements the ContentLearningEventOrderIndexResponse interface.
 */
export function instanceOfContentLearningEventOrderIndexResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "internal" in value;
    isInstance = isInstance && "invitation_link" in value;

    return isInstance;
}

export function ContentLearningEventOrderIndexResponseFromJSON(json: any): ContentLearningEventOrderIndexResponse {
    return ContentLearningEventOrderIndexResponseFromJSONTyped(json, false);
}

export function ContentLearningEventOrderIndexResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentLearningEventOrderIndexResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'internal': json['internal'],
        'invitation_link': json['invitation_link'],
        'order_creator': !exists(json, 'order_creator') ? undefined : ContentLearningEventShowResponseOrdersInnerOrderCreatorFromJSON(json['order_creator']),
        'company_email': !exists(json, 'company_email') ? undefined : json['company_email'],
        'participants_count': !exists(json, 'participants_count') ? undefined : json['participants_count'],
        'license_count': !exists(json, 'license_count') ? undefined : json['license_count'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'settled_at': !exists(json, 'settled_at') ? undefined : (new Date(json['settled_at'])),
        'submitted_at': !exists(json, 'submitted_at') ? undefined : (new Date(json['submitted_at'])),
        'order_number': !exists(json, 'order_number') ? undefined : json['order_number'],
        'payment_method': !exists(json, 'payment_method') ? undefined : json['payment_method'],
        'learning_event': !exists(json, 'learning_event') ? undefined : ContentLearningEventParticipantIndexResponseLearningEventFromJSON(json['learning_event']),
        'participants': !exists(json, 'participants') ? undefined : ((json['participants'] as Array<any>).map(BulkSendInvitationResponseInvitedUsersInnerFromJSON)),
        'company_space': !exists(json, 'company_space') ? undefined : ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSON(json['company_space']),
    };
}

export function ContentLearningEventOrderIndexResponseToJSON(value?: ContentLearningEventOrderIndexResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'internal': value.internal,
        'invitation_link': value.invitation_link,
        'order_creator': ContentLearningEventShowResponseOrdersInnerOrderCreatorToJSON(value.order_creator),
        'company_email': value.company_email,
        'participants_count': value.participants_count,
        'license_count': value.license_count,
        'note': value.note,
        'status': value.status,
        'settled_at': value.settled_at === undefined ? undefined : (value.settled_at.toISOString()),
        'submitted_at': value.submitted_at === undefined ? undefined : (value.submitted_at.toISOString()),
        'order_number': value.order_number,
        'payment_method': value.payment_method,
        'learning_event': ContentLearningEventParticipantIndexResponseLearningEventToJSON(value.learning_event),
        'participants': value.participants === undefined ? undefined : ((value.participants as Array<any>).map(BulkSendInvitationResponseInvitedUsersInnerToJSON)),
        'company_space': ContentInCompanySpaceUpgradeResponseOwningCompanySpaceToJSON(value.company_space),
    };
}

